<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="main-card" flat>
      <v-tabs
        v-model="tabs"
        background-color="transparent"
     
        show-arrows
        slider-color="transparent"
        class="custom-tabs"
      >
        <v-tab v-if="profile_relative_tab.indexOf('Under_leave_late_marks_tab_student_leave') !== -1"
          :class="['custom-tab', 'first-tab', { 'active-tab': tabs === 0 }]"
        >
          <v-icon class="mr-2">mdi mdi-calendar-today-outline</v-icon>Student Leaves
        </v-tab>
        <v-tab :class="['custom-tab', { 'active-tab': tabs === 1 }]" v-if="profile_relative_tab.indexOf('Under_leave_late_marks_tab_student_late_marks') !== -1">
          <v-icon class="mr-2">mdi mdi-timer-alert-outline</v-icon>Student Late Marks
        </v-tab>
       
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_leave_late_marks_tab_student_leave') !== -1">
          <v-card flat>
            <br>
            <v-toolbar flat dense class="custom-toolbar ma-2">
      <v-toolbar-title>Student Leave Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
          <v-row class="justify-center">
                            <v-col cols="4">
                              <v-autocomplete
                                dense
                                outlined
                                rounded
                                v-model="ay"
                                :items="academic_year_list"
                               item-text="ay"
                                item-value="id"
                                label="Academis Year"
                                @change="getStudentLeaveoncall()"
                                persistent-hint
                              single-line
                              ></v-autocomplete>
                            </v-col>
                          </v-row>
                            <v-data-table
      :headers="headers"
      :items="student_leave_list"
       :sort-by="['srno']"
              class="elevation-1"
              style="padding: 10px"
    
      dense
      :search="search"
        hide-default-header
    >
       <!-- Header slot to apply background color -->
              <template v-slot:header="{ props }">
                <thead>
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.value"
                      class="custom-header"
                    >
                      {{ header.text }}
                    </th>
                  </tr>
                </thead>
              </template>
      <template v-slot:top>
        <v-toolbar flat dense color="white">
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          
      
        </v-toolbar>
      </template>

    
    </v-data-table>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="profile_relative_tab.indexOf('Under_leave_late_marks_tab_student_late_marks') !== -1">
          <v-card flat class=" pa-4">
           <UnderDevelopement></UnderDevelopement>
          </v-card>
        </v-tab-item>
    
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import UnderDevelopement from "@/components/shared/UnderDevelopement.vue";
export default {
       components: { UnderDevelopement },
  props: {
    learner: {
      type: [String, Number], // Adjust type based on your actual value
      required: true,
    },
     profile_relative_tab: {
    type: Array,
    default: () => []
  }

  },
  data() {
    return {
      save_loader: false,
    
      editedIndex: -1,
    ay:'',
    
 
    
      valid: true,
      menu: false,
      tabs: 0,
      dialog: false,
    
    
      academic_year_list: [],
      student_leave_list:[],
     
      color: "",
      snackbar: false,
      snackbar_msg: "",
     
      search: "",
      
      headers: [
        {
          text: "Sr.No",
          align: "left",
          sortable: false,
          value: "srno",
        },
        {
          text: "From Date",
          align: "left",
          sortable: false,
          value: "start_date",
        },
         {
          text: "To Date",
          align: "left",
          sortable: false,
          value: "end_date",
        },
         {
          text: "#Days",
          align: "left",
          sortable: false,
          value: "days",
        },
         {
          text: "Reason",
          align: "left",
          sortable: false,
          value: "reasons",
        },
           {
          text: "Approved By",
          align: "left",
          sortable: false,
          value: "approved_by",
        },
          {
          text: "Application Date",
          align: "left",
          sortable: false,
          value: "application_date",
        },
    
      ],
  
    };
  },
  watch: {
    learner(newVal, oldVal) {
      if (newVal) {
        this.getStudentLeave();
      
      }
    },
  },
  computed: {
    
 
  },

  methods: {
    
  
  

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getStudentLeave() {
       
      const data = {
        learner: this.learner,
      };
      axios.post("/parent/getStudentLeave", data).then((res) => {
        if (res.data.flag == "YES") {
          this.academic_year_list = res.data.academic_year_list;
          this.student_leave_list = res.data.student_leave_list;
          this.ay=res.data.ay;
        } else {
          this.showSnackbar("error", res.data.snackbar);
        }
        this.fetch_loader = false;
      });
    },
    getStudentLeaveoncall() {
      
       this.student_leave_list=[];
      const data = {
        learner: this.learner,
         ay: this.ay,

      };
      axios.post("/parent/getStudentLeave", data).then((res) => {
        if (res.data.flag == "YES") {
         
          this.student_leave_list = res.data.student_leave_list;

          
        } else {
          this.showSnackbar("error", res.data.snackbar);
        }
        this.fetch_loader = false;
      });
    },


   

   
  },
  mounted() {
    this.learner = localStorage.getItem("learner_for_profile");
    if (this.learner) {
      this.getStudentLeave();
   
    }

    this.awspath = localStorage.getItem("awspath");
  },
};
</script>

<style scoped>
.custom-toolbar {
  background: linear-gradient(to right, #a8edea, #e4d0ff);
  background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.sibling-table td,
tr,
th {
  /* border: 1px solid navy; */
  border-collapse: collapse;
}

.button-77 {
  /* background-color: initial; */
  /* border-style: none; */
  color: #fff;
  cursor: pointer;
  /* font-size: 16px; */
  font-weight: 800;
  vertical-align: middle;
  z-index: 0;
  /* padding: 19px 16px; */
}

/* @media (min-width: 768px) {
  .button-77 {
    padding: 19px 32px;
  }
} */

.button-77:before,
.button-77:after {
  border-radius: 80px;
}

.button-77:before {
  background-color: rgba(249, 58, 19, 0.32);
  content: "";
}

.button-77:after {
  /* background-color: initial; */
  background-image: linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
  bottom: 4px;
  content: "";
  display: block;
  left: 4px;
  overflow: hidden;
  position: absolute;
  right: 4px;
  top: 4px;
  transition: all 100ms ease-out;
  z-index: -1;
}

.button-77:hover:not(:disabled):after {
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  transition-timing-function: ease-in;
}

.button-77:active:not(:disabled) {
  color: #ccc;
}

.button-77:active:not(:disabled):after {
  background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.2)
    ),
    linear-gradient(92.83deg, #ff7426 0, #f93a13 100%);
  bottom: 4px;
  left: 4px;
  right: 4px;
  top: 4px;
}

.button-77:disabled {
  cursor: default;
  opacity: 0.24;
}

.custom-toolbar {
  background: linear-gradient(to right, #a8edea, #e4d0ff);
  background: linear-gradient(to right, #a8edea, #e4d0ff);
}

.main-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.custom-tabs {
  background: linear-gradient(to right, #b2d8f7, #f4d1f4);
  border-radius: 30px;
  padding: 2px;
  min-height: 50px;
    padding: 0 16px;
}

.custom-tab {
  font-weight: normal;
  color: black;
  text-transform: uppercase;
  font-size: 14px;
  min-height: 40px;
  border-radius: 0;
}

.first-tab {
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.last-tab {
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.active-tab {
  background: white !important;
  color: black !important;
  font-weight: bold !important;
}

.under-development {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f5f6fa;
  text-align: center;
}

.content {
  padding: 20px;
  border: 2px dashed #ccc;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #333;
  margin-top: 20px;
  font-size: 24px;
}

p {
  color: #666;
  font-size: 16px;
}

.custom-header {
  background-color: #e0e0e0 !important;
  color: black !important; /* Optional: makes text readable */
  font-weight: bold;
}
.custom-header {
  background: linear-gradient(to right, #ffe0b2, #ffccbc);

  color: black !important; /* Optional: makes text readable */
  font-weight: bold;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
</style>
